<template>
    <v-app>
        <v-dialog
            v-model="$store.getters['CreateAudienceStore/getSchedulerModalStatus']"
            persistent
            fullscreen
            hide-overlay
            transition="slide-x-reverse-transition"
            scrollable
            :content-class="isMobile"
        >
            <v-card tile>
                <v-toolbar
                    flat
                    dark
                    color="primary"
                >
                    <v-toolbar-title>Create Custom Scheduler</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-toolbar-items>
                        <v-btn
                            icon
                            dark
                            @click="close()"
                        >
                            <v-icon>mdi-close</v-icon>
                        </v-btn>
                    </v-toolbar-items>
                </v-toolbar>
                <v-card-text>
                    <div class="card createActivation">
                        <div class="card-body">

                            <SchedulerStepper></SchedulerStepper>

                            <v-form ref="step_1">
                                <div v-if="step === 1">

                                    <!-- Name -->
                                    <div class="row">
                                        <div class="form-inline col-md-2">
                                            <v-tooltip top>
                                                <template v-slot:activator="{ on, attrs }">
                                                    <v-btn
                                                        icon
                                                        v-bind="attrs"
                                                        v-on="on"
                                                    >
                                                        <v-icon color="grey lighten-1" class="tooltip-small">
                                                            mdi-information-outline
                                                        </v-icon>
                                                    </v-btn>
                                                </template>
                                                <span>Scheduler name.</span>
                                            </v-tooltip>

                                            <i class="fas fa-cog" ></i> <span style="padding-left: 5px;"> General</span>
                                        </div>
                                        <div class="form-group col-md-6 mb-0">
                                            <v-text-field
                                                v-model="name"
                                                label="Scheduler Name"
                                                :rules="[requiredField]"
                                                :disabled="$store.getters['CreateAudienceStore/isFieldLoadingStatus']('description_0')"
                                                :loading="$store.getters['CreateAudienceStore/isFieldLoadingStatus']('description_0')"
                                            ></v-text-field>
                                        </div><!--form-group-->
                                    </div>
                                    <hr style="opacity: 0.3;">

                                    <!-- Audience Type Selection -->
                                    <div class="row">
                                        <div class="form-inline col-md-2">
                                            <v-tooltip top>
                                                <template v-slot:activator="{ on, attrs }">
                                                    <v-btn
                                                        icon
                                                        v-bind="attrs"
                                                        v-on="on"
                                                    >
                                                        <v-icon color="grey lighten-1" class="tooltip-small">
                                                            mdi-information-outline
                                                        </v-icon>
                                                    </v-btn>
                                                </template>
                                                <span>Create new audience or <br> select existing one.</span>
                                            </v-tooltip>

                                            <i class="fas fa-user-friends"></i> <span style="padding-left: 5px;"> Audience </span>
                                        </div>
                                        <div class="col-6">
                                            <div class="d-flex flex-row">
                                                <div class="form-group mb-0 ending-type">
                                                    <v-radio-group
                                                        v-model="audience_type"
                                                        :rules="[requiredField]"
                                                        @change="audience_type_changed"
                                                    >
                                                        <v-radio :key="type.value" v-for="type in audience_types"
                                                            :label="type.text"
                                                            :value="type.value"
                                                        ></v-radio>
                                                    </v-radio-group>
                                                </div><!--form-group-->
                                            </div>
                                        </div>
                                    </div>
                                    <hr style="opacity: 0.3;" v-if="audience_type !== null">

                                    <!-- Custom audience creation -->
                                    <div class="row" v-if="audience_type === audience_types[0].value">
                                        <div class="form-group col-12 mb-0">

                                            <div class="activation-item-container-2">
                                                <div class="row">
                                                    <div class="form-inline col-md-2">
                                                        <v-tooltip top>
                                                            <template v-slot:activator="{ on, attrs }">
                                                                <v-btn
                                                                    icon
                                                                    v-bind="attrs"
                                                                    v-on="on"
                                                                >
                                                                    <v-icon color="grey lighten-1" class="tooltip-small">
                                                                        mdi-information-outline
                                                                    </v-icon>
                                                                </v-btn>
                                                            </template>
                                                            <span>Choose from the existing data-types.</span>
                                                        </v-tooltip>

                                                        <i class="fa fa-tasks"></i> <span style="padding-left: 5px;"> Data Set Type</span>
                                                    </div>
                                                    <div class="form-group col-md-3">
                                                        <v-autocomplete
                                                            v-model="analysis_type_0"
                                                            :items="$store.getters['CreateAudienceStore/getAnalysisTypes'](0)"
                                                            label="Data Type"
                                                            :rules="[requiredAnalysisType]"
                                                            :disabled="$store.getters['CreateAudienceStore/isFieldLoadingStatus']('analysis_type_0')"
                                                            :loading="$store.getters['CreateAudienceStore/isFieldLoadingStatus']('analysis_type_0')"
                                                        ></v-autocomplete>
                                                    </div><!--form-group-->
                                                </div>

                                                <LocationData
                                                    v-if="[
                                                        analyses.types.poi,
                                                        analyses.types.cohorts,
                                                        analyses.types.competitors,
                                                        analyses.types.anonymized
                                                        ].includes($store.getters['CreateAudienceStore/getAnalysisType'](0))"
                                                    data-set-order="0"
                                                    :analysis-type="$store.getters['CreateAudienceStore/getAnalysisType'](0)"
                                                ></LocationData>

                                                <AnonymizedFields
                                                    v-if="[
                                                        analyses.types.anonymized
                                                        ].includes($store.getters['CreateAudienceStore/getAnalysisType'](0))"
                                                    data-set-order="0"
                                                    :analysis-type="$store.getters['CreateAudienceStore/getAnalysisType'](0)"
                                                ></AnonymizedFields>

                                                <AppsData
                                                    v-if="[analyses.types.apps].includes($store.getters['CreateAudienceStore/getAnalysisType'](0))"
                                                    data-set-order="0"
                                                    :analysis-type="$store.getters['CreateAudienceStore/getAnalysisType'](0)"
                                                ></AppsData>

                                                <CompetitorsData
                                                    v-if="[analyses.types.competitors].includes(analysis_type_0)"
                                                    data-set-order="comp_0"
                                                    :analysis-type="$store.getters['CreateAudienceStore/getAnalysisType'](0)"
                                                ></CompetitorsData>

                                                <Distance
                                                    v-if="[analyses.types.competitors].includes(analysis_type_0)"
                                                    data-set-order="comp_0"
                                                    :analysis-type="$store.getters['CreateAudienceStore/getAnalysisType'](0)"
                                                ></Distance>

                                                <Limits
                                                    v-if="[
                                                    analyses.types.poi,
                                                    analyses.types.competitors
                                                    ].includes($store.getters['CreateAudienceStore/getAnalysisType'](0))"
                                                    data-set-order="0"
                                                    :analysis-type="$store.getters['CreateAudienceStore/getAnalysisType'](0)"
                                                ></Limits>

                                            </div>

                                            <div class="row" v-if="[analyses.types.poi, analyses.types.apps, analyses.types.competitors, analyses.types.cohorts].includes($store.getters['CreateAudienceStore/getAnalysisType'](0))">
                                                <div class="form-inline col-md-2">
                                                    <v-tooltip top>
                                                        <template v-slot:activator="{ on, attrs }">
                                                            <v-btn
                                                                icon
                                                                v-bind="attrs"
                                                                v-on="on"
                                                            >
                                                                <v-icon color="grey lighten-1" class="tooltip-small">
                                                                    mdi-information-outline
                                                                </v-icon>
                                                            </v-btn>
                                                        </template>
                                                        <span>Select if you want to cross audiences with different operators.</span>
                                                    </v-tooltip>

                                                    <i class="fas fa-database"></i> <span style="padding-left: 5px;">Operator</span>
                                                </div>

                                                <div class="col-md-10 queryButtons">
                                                    <v-radio-group row v-model="query">
                                                        <v-radio
                                                            label="None"
                                                            value="Single"
                                                            active-class="checked"
                                                            @click="$store.commit('CreateAudienceStore/SET_QUERY', 'Single')"
                                                        ></v-radio>
                                                        <v-radio
                                                            label="AND"
                                                            value="AND"
                                                            active-class="checked"
                                                            @click="$store.commit('CreateAudienceStore/SET_QUERY', 'AND')"
                                                        ></v-radio>
                                                        <v-radio
                                                            label="OR"
                                                            value="OR"
                                                            active-class="checked"
                                                            @click="$store.commit('CreateAudienceStore/SET_QUERY', 'OR')"
                                                        ></v-radio>
                                                        <v-radio
                                                            label="NOT IN"
                                                            value="NOTIN"
                                                            active-class="checked"
                                                            @click="$store.commit('CreateAudienceStore/SET_QUERY', 'NOTIN')"
                                                        ></v-radio>
                                                    </v-radio-group>
                                                </div>
                                            </div>

                                            <div class="activation-item-container-2" v-if="$store.getters['CreateAudienceStore/getQuery'] !== 'Single' && $store.getters['CreateAudienceStore/getAnalysisType'](0) !== analyses.types.anonymized">
                                                <div class="row">
                                                    <div class="form-inline col-md-2">
                                                        <v-tooltip top>
                                                            <template v-slot:activator="{ on, attrs }">
                                                                <v-btn
                                                                    icon
                                                                    v-bind="attrs"
                                                                    v-on="on"
                                                                >
                                                                    <v-icon color="grey lighten-1" class="tooltip-small">
                                                                        mdi-information-outline
                                                                    </v-icon>
                                                                </v-btn>
                                                            </template>
                                                            <span>Choose from the existing data-types.</span>
                                                        </v-tooltip>

                                                        <i class="fa fa-tasks"></i> <span style="padding-left: 5px;"> Data Set Type</span>
                                                    </div>
                                                    <div class="form-group col-md-3">
                                                        <v-autocomplete
                                                            v-model="analysis_type_1"
                                                            :items="$store.getters['CreateAudienceStore/getAnalysisTypes'](1)"
                                                            label="Data Type"
                                                            :rules="[requiredAnalysisType]"
                                                        ></v-autocomplete>
                                                    </div><!--form-group-->
                                                </div>

                                                <LocationData
                                                    v-if="[
                                                        analyses.types.poi,
                                                        analyses.types.cohorts,
                                                        analyses.types.competitors,
                                                        ].includes($store.getters['CreateAudienceStore/getAnalysisType'](1))"
                                                    data-set-order="1"
                                                    :analysis-type="$store.getters['CreateAudienceStore/getAnalysisType'](1)"
                                                ></LocationData>

                                                <AnonymizedFields
                                                    v-if="[
                                                        analyses.types.anonymized
                                                        ].includes($store.getters['CreateAudienceStore/getAnalysisType'](1))"
                                                    data-set-order="1"
                                                    :analysis-type="$store.getters['CreateAudienceStore/getAnalysisType'](1)"
                                                ></AnonymizedFields>

                                                <AppsData
                                                    v-if="[analyses.types.apps].includes($store.getters['CreateAudienceStore/getAnalysisType'](1))"
                                                    data-set-order="1"
                                                    :analysis-type="$store.getters['CreateAudienceStore/getAnalysisType'](1)"
                                                ></AppsData>

                                                <CompetitorsData
                                                    v-if="[analyses.types.competitors].includes(analysis_type_1)"
                                                    data-set-order="comp_1"
                                                    :analysis-type="$store.getters['CreateAudienceStore/getAnalysisType'](1)"
                                                ></CompetitorsData>

                                                <Distance
                                                    v-if="[analyses.types.competitors].includes(analysis_type_1)"
                                                    data-set-order="comp_1"
                                                    :analysis-type="$store.getters['CreateAudienceStore/getAnalysisType'](1)"
                                                ></Distance>

                                                <Limits
                                                    v-if="[
                                                    analyses.types.poi,
                                                    analyses.types.competitors
                                                    ].includes($store.getters['CreateAudienceStore/getAnalysisType'](1))"
                                                    data-set-order="1"
                                                    :analysis-type="$store.getters['CreateAudienceStore/getAnalysisType'](1)"
                                                ></Limits>
                                            </div>

                                            <div class="activation-item-container-2">
                                                <Filters
                                                    v-if="[
                                                        $store.getters['CreateAudienceStore/getAnalysisType'](0),
                                                        $store.getters['CreateAudienceStore/getAnalysisType'](1)
                                                    ].includes(analyses.types.poi) ||
                                                    [
                                                        $store.getters['CreateAudienceStore/getAnalysisType'](0),
                                                        $store.getters['CreateAudienceStore/getAnalysisType'](1)
                                                    ].includes(analyses.types.competitors) ||
                                                    [
                                                        $store.getters['CreateAudienceStore/getAnalysisType'](0)
                                                    ].includes(analyses.types.anonymized)"
                                                    data-set-order="0"
                                                    :analysis-type="$store.getters['CreateAudienceStore/getAnalysisType'](0)"
                                                ></Filters>
                                            </div>

                                            <div class="activation-item-container-2">
                                                <div class="row" v-if="$store.getters['CreateAudienceStore/getAnalysisType'](0) !== analyses.types.anonymized">
                                                    <div class="form-inline col-md-2">
                                                        <v-tooltip top>
                                                            <template v-slot:activator="{ on, attrs }">
                                                                <v-btn
                                                                    icon
                                                                    v-bind="attrs"
                                                                    v-on="on"
                                                                >
                                                                    <v-icon color="grey lighten-1" class="tooltip-small">
                                                                        mdi-information-outline
                                                                    </v-icon>
                                                                </v-btn>
                                                            </template>
                                                            <span>Save this custom audience as a cohort <br> (group of mobile devices) to analyze it later.</span>
                                                        </v-tooltip>

                                                        <i class="fas fa-layer-group"></i> <span style="padding-left: 5px;">Create Cohort </span>
                                                    </div>

                                                    <div class="form-group col-md-2 push-down-36">
                                                        <v-switch
                                                            v-model="create_cohort"
                                                            inset
                                                        ></v-switch>
                                                    </div><!--form-group-->
                                                </div>

                                                <AnalysesSelection
                                                    v-if="$store.getters['CreateAudienceStore/getAnalysisType'](0) !== analyses.types.anonymized"
                                                ></AnalysesSelection>

                                                <CrossVisitation
                                                    v-if="$store.getters['CreateAudienceStore/getAnalysesCrossVisitationStatus']"
                                                    :row-style="{ backgroundColor: colors.cv_bg }"
                                                ></CrossVisitation>

                                                <Frequency
                                                    v-if="$store.getters['CreateAudienceStore/getAnalysesFrequencyStatus']"
                                                    :row-style="{ backgroundColor: colors.fq_bg }"
                                                ></Frequency>
                                            </div>
                                        </div><!--form-group-->
                                    </div>

                                    <!-- Custom audience selection -->
                                    <div class="row" v-if="audience_type === audience_types[1].value">
                                        <div class="form-inline col-md-2">
                                            <v-tooltip top>
                                                <template v-slot:activator="{ on, attrs }">
                                                    <v-btn
                                                        icon
                                                        v-bind="attrs"
                                                        v-on="on"
                                                    >
                                                        <v-icon color="grey lighten-1" class="tooltip-small">
                                                            mdi-information-outline
                                                        </v-icon>
                                                    </v-btn>
                                                </template>
                                                <span>Select existing audience.</span>
                                            </v-tooltip>

                                            <i class="fas fa-database"></i> <span style="padding-left: 5px;"> Audience</span>
                                        </div>
                                        <div class="form-group col-md-6 mb-0">
                                            <v-autocomplete
                                                v-model="audience"
                                                :items="$store.getters['CreateAudienceStore/getSchedulerAudiences']"
                                                label="My Audiences"
                                                :rules="[requiredFieldSelect]"
                                                @change="audience_changed"
                                                :disabled="$store.getters['CreateAudienceStore/isFieldLoadingStatus']('scheduler_audiences')"
                                                :loading="$store.getters['CreateAudienceStore/isFieldLoadingStatus']('scheduler_audiences')"
                                            ></v-autocomplete>
                                        </div><!--form-group-->
                                    </div>
                                </div>
                            </v-form>

                            <v-form ref="step_2">
                                <div v-if="step === 2">
                                    <!-- Recurrences -->
                                    <div class="row">
                                        <div class="form-inline col-md-2">
                                            <v-tooltip top>
                                                <template v-slot:activator="{ on, attrs }">
                                                    <v-btn
                                                        icon
                                                        v-bind="attrs"
                                                        v-on="on"
                                                    >
                                                        <v-icon color="grey lighten-1" class="tooltip-small">
                                                            mdi-information-outline
                                                        </v-icon>
                                                    </v-btn>
                                                </template>
                                                <span>Custom recurrence settings for starting of the <br> automated process.</span>
                                            </v-tooltip>

                                            <i class="fas fa-sync-alt"></i> <span style="padding-left: 5px;"> Custom Recurrence</span>
                                        </div>
                                        <div class="col-10">
                                            <div class="d-flex flex-row">
                                                <div class="form-group mb-0">
                                                    <span class="mt-7 d-inline-block">Analysis will start on </span>
                                                </div><!--form-group-->
                                                <div class="form-group mb-0 mx-2">
                                                    <div class="d-flex flex-row">
                                                        <v-menu
                                                            v-model="start_date_menu"
                                                            :close-on-content-click="false"
                                                            :nudge-right="40"
                                                            transition="scale-transition"
                                                            offset-y
                                                            min-width="auto"
                                                        >
                                                            <template v-slot:activator="{ on, attrs }">
                                                                <v-text-field
                                                                    v-model="start_date"
                                                                    class="custom-input"
                                                                    v-bind="attrs"
                                                                    v-on="on"
                                                                    :rules="[requiredStartDate]"
                                                                ></v-text-field>
                                                            </template>
                                                            <v-date-picker
                                                                header-color="#fb7e42"
                                                                color="#fb7e42"
                                                                v-model="start_date"
                                                                @input="start_date_menu = false"
                                                                :min="today"
                                                            ></v-date-picker>
                                                        </v-menu>
                                                        <span class="ml-1 mt-7 d-inline-block"> at </span>
                                                        <v-text-field
                                                            type="time"
                                                            v-model="time"
                                                            class="custom-input ml-2"
                                                        ></v-text-field>
                                                    </div>
                                                </div><!--form-group-->
                                                <div class="form-group mb-0">
                                                    <span class="mt-7 d-inline-block">and repeat on a</span>
                                                </div><!--form-group-->
                                                <div class="form-group mb-0 mx-2">
                                                    <v-autocomplete
                                                        class="custom-input"
                                                        v-model="act_frequency"
                                                        :items="repeat_options"
                                                    ></v-autocomplete>
                                                </div><!--form-group-->
                                                <div class="form-group mb-0">
                                                    <span class="mt-7 d-inline-block">basis.</span>
                                                </div><!--form-group-->
                                            </div>

                                            <div class="d-flex flex-row">
                                                <div class="form-group mb-0">
                                                    <span class="mt-7 d-inline-block">Analyze signals for </span>
                                                </div><!--form-group-->
                                                <div class="form-group mb-0 mx-2">
                                                    <v-autocomplete
                                                        class="custom-input"
                                                        v-model="recurrence_type"
                                                        :items="recurrence_types"
                                                    ></v-autocomplete>
                                                </div><!--form-group-->
                                                <div class="form-group mb-0" v-if="recurrence_type === 3">
                                                    <v-text-field
                                                        type="number"
                                                        v-model="period"
                                                        class="custom-input"
                                                        :rules="[periodValue]"
                                                        @change="setDynamicDate"
                                                    ></v-text-field>
                                                </div>
                                                <div class="form-group mb-0 ml-2" v-if="recurrence_type === 3">
                                                    <span class="mt-7 d-inline-block">days backwards.</span>
                                                </div><!--form-group-->
                                            </div>
                                            <div v-if="recurrence_type === 3 && act_frequency === 'daily'" class="d-flex flex-row">
                                                <span class="alert alert-info">
                                                    Please note that the generated POI data is delayed by 72 hours. As a result, <strong>{{ dynamic_date }}</strong> will be the first processing day.
                                                </span>
                                            </div>
                                            <div v-if="recurrence_type === 2 && Number(start_date.slice(-2)) < 4" class="d-flex flex-row">
                                                <span class="alert alert-info">
                                                    Please note that the generated POI data is delayed by 72 hours. As a result, selected date to run should be after 3rd in month.
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                    <hr style="opacity: 0.3;">

                                    <!-- Ending -->
                                    <div class="row">
                                        <div class="form-inline col-md-2">
                                            <v-tooltip top>
                                                <template v-slot:activator="{ on, attrs }">
                                                    <v-btn
                                                        icon
                                                        v-bind="attrs"
                                                        v-on="on"
                                                    >
                                                        <v-icon color="grey lighten-1" class="tooltip-small">
                                                            mdi-information-outline
                                                        </v-icon>
                                                    </v-btn>
                                                </template>
                                                <span>Setting under which conditions the automated process <br> should be completed.</span>
                                            </v-tooltip>

                                            <i class="fas fa-hourglass-end"></i> <span style="padding-left: 5px;"> Expire</span>
                                        </div>
                                        <div class="col-10">
                                            <div class="row">
                                                <div class="col-3">
                                                    <div class="d-flex flex-row">
                                                        <div class="form-group mb-0 ending-type">
                                                            <v-radio-group
                                                                v-model="ending_type"
                                                                :rules="[requiredField]"
                                                            >
                                                                <v-radio
                                                                    v-for="item in ending_types"
                                                                    :key="item.value"
                                                                    :label="item.text"
                                                                    :value="item.value"
                                                                ></v-radio>
                                                            </v-radio-group>
                                                        </div><!--form-group-->
                                                    </div>
                                                </div>
                                                <div class="col-4" v-if="ending_type === ending_types[1].value">
                                                    <div class="d-flex flex-row">
                                                        <div class="form-group mb-0">
                                                            <span class="mt-7 d-inline-block">After</span>
                                                        </div><!--form-group-->
                                                        <div class="form-group mb-0 mx-2">
                                                            <v-text-field
                                                                type="number"
                                                                v-model="recurrences"
                                                                class="custom-input"
                                                            ></v-text-field>
                                                        </div><!--form-group-->
                                                        <div class="form-group mb-0">
                                                            <span class="mt-7 d-inline-block">recurrences</span>
                                                        </div><!--form-group-->
                                                    </div>
                                                </div>
                                                <div class="col-4 mt-2" v-if="ending_type === ending_types[2].value">
                                                    <div class="d-flex flex-row">
                                                        <div class="form-group mb-0">
                                                            <v-menu
                                                                v-model="end_date_menu"
                                                                :close-on-content-click="false"
                                                                :nudge-right="40"
                                                                transition="scale-transition"
                                                                offset-y
                                                                min-width="auto"
                                                            >
                                                                <template v-slot:activator="{ on, attrs }">
                                                                    <v-text-field
                                                                        v-model="end_date"
                                                                        class="custom-input"
                                                                        v-bind="attrs"
                                                                        label="End Date"
                                                                        v-on="on"
                                                                        :rules="[requiredEndDate]"
                                                                    ></v-text-field>
                                                                </template>
                                                                <v-date-picker
                                                                    header-color="#fb7e42"
                                                                    color="#fb7e42"
                                                                    v-model="end_date"
                                                                    @input="end_date_menu = false"
                                                                    :min="today"
                                                                ></v-date-picker>
                                                            </v-menu>
                                                        </div><!--form-group-->
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <hr style="opacity: 0.3;">

                                    <!-- Activation -->
                                    <div class="row">
                                        <div class="form-inline col-md-2">
                                            <v-tooltip top>
                                                <template v-slot:activator="{ on, attrs }">
                                                    <v-btn
                                                        icon
                                                        v-bind="attrs"
                                                        v-on="on"
                                                    >
                                                        <v-icon color="grey lighten-1" class="tooltip-small">
                                                            mdi-information-outline
                                                        </v-icon>
                                                    </v-btn>
                                                </template>
                                                <span>Activation process is automatically delivering <br> the data to specific endpoint.</span>
                                            </v-tooltip>

                                            <i class="fas fa-check"></i> <span style="padding-left: 5px;"> Activation</span>
                                        </div>
                                        <div class="col-6">
                                            <div class="d-flex flex-row">
                                                <div class="form-group mb-0 ending-type">
                                                    <div class="d-inline-block">
                                                        <span class="d-inline-block mr-2 cursor-pointer" @click="auto_activate = !auto_activate">OFF</span>
                                                        <v-switch
                                                            class="d-inline-block"
                                                            v-model="auto_activate"
                                                            inset
                                                        ></v-switch>
                                                        <span class="d-inline-block ml-n2 cursor-pointer" @click="auto_activate = !auto_activate">ON</span>
                                                    </div>
                                                </div><!--form-group-->
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </v-form>

                            <ActivationEndpoints
                                v-if="step === 3"
                                ref="step_3"
                                :step=3
                                is-scheduler
                            ></ActivationEndpoints>

                            <ActivationProperties
                                v-if="step === 4"
                                ref="step_4"
                                :step=4
                                is-scheduler
                            ></ActivationProperties>

                            <ActivationDataStreams
                                v-if="step === 5"
                                ref="step_5"
                                :step=5
                                is-scheduler
                            ></ActivationDataStreams>

                            <hr>
                            <div class="row">
                                <div class="col-1 text-left">
                                    <button @click.prevent="close()" class="btn btn-danger">Cancel</button>
                                </div>
                                <div class="col-1 text-right" v-if="step !== 1">
                                    <button @click.prevent="changeStep('decrease')" class="btn btn-warning text-white mx-1">Back</button>
                                </div>
                                <div class="col-1 text-right" v-if="is_next_step_allowed" :class="(step === 1) || (auto_activate === 0 && step === 2) ? 'offset-10' : 'offset-9'">
                                    <button @click.prevent="changeStep('increase')" class="btn btn-warning text-white">Next</button>
                                </div>
                                <div class="col-1 text-right offset-9" v-if="is_submit_allowed">
                                    <button @click.prevent="submitData()" class="btn btn-success">Create</button>
                                </div>
                            </div>
                        </div>
                    </div><!--card-->
                </v-card-text>
                <div style="flex: 1 1 auto;"></div>
            </v-card>
        </v-dialog>
    </v-app>
</template>

<script>
import Modal from '../Modal'
import LocationData from "./partials/poi/LocationData.vue";
import AppsData from "./partials/create/apps/AppsData.vue";
import CompetitorsData from "./partials/competitors/CompetitorsData.vue";
import Distance from "./partials/competitors/Distance.vue";
import Limits from "./partials/shared/Limits.vue";
import Filters from "./partials/shared/Filters.vue";
import AnalysesSelection from "./partials/shared/analyses/AnalysesSelection.vue";
import CrossVisitation from "./partials/shared/analyses/CrossVisitation.vue";
import Frequency from "./partials/shared/analyses/Frequency.vue";
import SchedulerStepper from "./partials/create/SchedulerStepper.vue";
import ActivationEndpoints from "./partials/activation/ActivationEndpoints.vue";
import ActivationProperties from "./partials/activation/ActivationProperties.vue";
import ActivationDataStreams from "./partials/activation/ActivationDataStreams.vue";
import analyses from "../../mixin/analyses";
import AnonymizedFields from "./partials/create/anonymized/AnonymizedFields.vue";

export default {
    name: "CreateNewScheduler",
    components: {
        AnonymizedFields,
        ActivationDataStreams,
        ActivationProperties,
        ActivationEndpoints,
        SchedulerStepper,
        Frequency,
        CrossVisitation,
        AnalysesSelection,
        Filters,
        Limits,
        Distance,
        CompetitorsData,
        AppsData,
        Modal,
        LocationData
    },
    props: [
        'dataObject'
    ],
    data: () => ({
        start_date_menu: false,
        end_date_menu: false,
        audience_types: [
            {
                value: 1,
                text: 'Create New Audience'
            },
            {
                value: 2,
                text: 'Select Existing Audience'
            },
        ],
        repeat_options: [
            {
                value: 'daily',
                text: 'Daily'
            },
            {
                value: 'weekly',
                text: 'Weekly'
            },
            {
                value: 'bi-weekly',
                text: 'Bi-Weekly'
            },
            {
                value: 'monthly',
                text: 'Monthly'
            },
        ],
        recurrence_types: [
            {
                value: 1,
                text: 'Last Week'
            },
            {
                value: 2,
                text: 'Last Month'
            },
            {
                value: 3,
                text: 'Custom'
            }
        ],
        ending_types: [
            {
                value: 1,
                text: 'Never'
            },
            {
                value: 2,
                text: 'Recurrences'
            },
            {
                value: 3,
                text: 'Custom Date'
            },
        ],

        dynamic_date: '',

        today: '',
        time: '10:00',

        requiredAudience: v => v && v > 0 || 'Limit audience must be greater then 0',
        requiredField: v => v && true || 'This field is required',
        requiredFileField: v => v || 'This field is required',
        requiredFieldSelect: v => v && v > 0 || 'This field is required',
        requiredPricingModel: v => v && v.length > 5 || 'Pricing model is required',
        requiredStartDate: v => v && v.length > 0 || 'Start Date field is required',
        requiredEndDate: v => v && v.length > 0 || 'End Date field is required',

        requiredAnalysisType: v => v && v.length > 0 || 'Data Sets field is required',
    }),
    methods: {
        submitData() {
            this.prepareRequiredDataBeforeSubmit()

            if (this.step === 2) {
                if (this.$refs['step_' + this.step].validate()) {
                    this.$store.dispatch('CreateAudienceStore/createNewScheduler')
                }
            } else {
                if (this.$refs['step_' + this.step].validateForm()) {
                    this.$store.dispatch('CreateAudienceStore/createNewScheduler')
                }
            }
        },
        prepareRequiredDataBeforeSubmit() {
            if (this.$store.getters['CreateAudienceStore/getSchedulerAudienceType'] === this.audience_types[0].value) {
                this.$store.dispatch('CreateAudienceStore/mergeLocationIds', 0)
                this.$store.dispatch('CreateAudienceStore/mergeLocationIds', 1)
                this.$store.dispatch('CreateAudienceStore/mergeLocationIds', 'cross')

                this.$store.dispatch('CreateAudienceStore/mergeBundleIds', 0)
                this.$store.dispatch('CreateAudienceStore/mergeBundleIds', 1)
            }
        },
        close() {
            this.$store.commit('CreateAudienceStore/RESET_STATE')
            this.$store.commit('ActivateAudienceStore/RESET_STATE')
            this.$store.commit('CreateAudienceStore/SET_SCHEDULER_MODAL', false)
        },
        changeStep(type) {
            let step = this.$store.getters['CreateAudienceStore/getSchedulerStep']

            if (type === 'increase') {
                this.$store.commit('ActivateAudienceStore/SET_STEP_STATUS', true)

                if (['step_1', 'step_2'].includes('step_' + this.step)) {
                    if (this.$refs['step_' + this.step].validate()) {
                        let new_step = step + 1
                        this.$store.commit('CreateAudienceStore/SET_SCHEDULER_STEP', new_step)
                    }
                } else {
                    if (this.$refs['step_' + this.step].validateForm()) {
                        this.$store.dispatch('CreateAudienceStore/increaseSchedulerProcessStep')
                    }
                }
            }
            if (type === 'decrease') {
                this.$store.commit('ActivateAudienceStore/SET_STEP_STATUS', false)

                this.$store.dispatch('CreateAudienceStore/decreaseSchedulerProcessStep')
            }
        },
        usePropsData() {
            this.$store.commit('CreateAudienceStore/SET_SCHEDULER_AUDIENCE_TYPE', this.audience_types[1].value)
            this.$store.commit('CreateAudienceStore/SET_NAME', this.dataObject.name)
            this.$store.commit('CreateAudienceStore/SET_SCHEDULER_SELECTED_AUDIENCE', this.dataObject.id)
            this.$store.dispatch('CreateAudienceStore/fetchAudiences')
            this.$store.dispatch('CreateAudienceStore/fetchAudience')

            this.$store.commit('CreateAudienceStore/SET_SCHEDULER_STEP', 2)
        },
        periodValue(v) {
            if (this.$store.getters['ActivateAudienceStore/getActivationAnalyses'].includes('anonymized')) {
                let date = new Date(this.$store.getters['CreateAudienceStore/getSchedulerStartDate'])
                let year = date.getFullYear()
                let month = date.getMonth()

                if (month === 1) {
                    year = year - 1
                    month = 12
                }

                let last_month_days = new Date(year, month, 0).getDate();
                let valid_days = last_month_days + date.getDate()

                if (v < valid_days) {
                    return true
                } else {
                    return 'Period must be lower then ' + valid_days + ' for this dataset'
                }
            } else {
                return true
            }
        },
        audience_type_changed() {
            if (this.$store.getters['CreateAudienceStore/getSchedulerAudienceType'] === this.audience_types[1].value) {
                this.$store.dispatch('CreateAudienceStore/fetchAudiences')
            }
        },
        audience_changed() {
            if (this.$store.getters['CreateAudienceStore/getSchedulerSelectedAudience']) {
                this.$store.dispatch('CreateAudienceStore/fetchAudience')
            }
        },
        setDynamicDate() {
            const final_date = new Date(this.$store.getters['CreateAudienceStore/getSchedulerStartDate'])
            final_date.setDate(final_date.getDate() - 2 - this.period)
            this.dynamic_date = final_date.toJSON().slice(0, 10)
        },
    },
    created() {
        const date = new Date()
        let date_string = date.toJSON().slice(0, 10)
        let full_time = date_string + ' ' + this.timeNow + ':00'
        this.time = this.timeNow

        this.$store.commit('CreateAudienceStore/SET_SCHEDULER_START_DATE', date_string)
        this.$store.commit('CreateAudienceStore/SET_SCHEDULER_FULL_TIME', full_time)
        this.today = date_string
        this.$store.commit('CreateAudienceStore/SET_SCHEDULER_TIME_ZONE', this.timezone)
    },
    computed: {
        is_submit_allowed() {
            return (this.auto_activate && this.step === 5) ||
                (!this.auto_activate && this.step === 2) ||
                (this.step === 4 && this.$store.getters['ActivateAudienceStore/getActivationAnalyses'].includes('anonymized'))
        },
        is_next_step_allowed() {
            return !this.is_submit_allowed
        },
        step: {
            get() {
                return this.$store.getters['CreateAudienceStore/getSchedulerStep']
            },
            set(value) {
                this.$store.commit('CreateAudienceStore/SET_SCHEDULER_STEP', value)
            }
        },
        name: {
            get() {
                return this.$store.getters['CreateAudienceStore/getActivationName']
            },
            set(value) {
                this.$store.commit('CreateAudienceStore/SET_NAME', value)
            }
        },
        audience_type: {
            get() {
                return this.$store.getters['CreateAudienceStore/getSchedulerAudienceType']
            },
            set(value) {
                this.$store.commit('CreateAudienceStore/SET_SCHEDULER_AUDIENCE_TYPE', value)
            }
        },
        audience: {
            get() {
                return this.$store.getters['CreateAudienceStore/getSchedulerSelectedAudience']
            },
            set(value) {
                this.$store.commit('CreateAudienceStore/SET_SCHEDULER_SELECTED_AUDIENCE', value)
            }
        },
        analysis_type_0: {
            get() {
                return this.$store.getters['CreateAudienceStore/getAnalysisType'](0)
            },
            set(value) {
                this.$store.commit('CreateAudienceStore/SET_ANALYSIS_TYPE', {
                    dataset: 0,
                    value: value
                })
            }
        },
        analysis_type_1: {
            get() {
                return this.$store.getters['CreateAudienceStore/getAnalysisType'](1)
            },
            set(value) {
                this.$store.commit('CreateAudienceStore/SET_ANALYSIS_TYPE', {
                    dataset: 1,
                    value: value
                })
            }
        },
        query: {
            get() {
                return this.$store.getters['CreateAudienceStore/getQuery']
            },
            set(value) {
                this.$store.commit('CreateAudienceStore/SET_QUERY', value)
            }
        },
        create_cohort: {
            get() {
                return this.$store.getters['CreateAudienceStore/getCreateCohortStatus']
            },
            set(value) {
                this.$store.commit('CreateAudienceStore/SET_CREATE_COHORT', value)
            }
        },
        start_date: {
            get() {
                return this.$store.getters['CreateAudienceStore/getSchedulerStartDate']
            },
            set(value) {
                let full_time = value + ' ' + this.time + ':00'

                this.$store.commit('CreateAudienceStore/SET_SCHEDULER_START_DATE', value)
                this.$store.commit('CreateAudienceStore/SET_SCHEDULER_FULL_TIME', full_time)
                this.setDynamicDate()
            }
        },
        end_date: {
            get() {
                return this.$store.getters['CreateAudienceStore/getSchedulerEndDate']
            },
            set(value) {
                this.$store.commit('CreateAudienceStore/SET_SCHEDULER_END_DATE', value)
            }
        },
        act_frequency: {
            get() {
                return this.$store.getters['CreateAudienceStore/getSchedulerActivationFrequency']
            },
            set(value) {
                this.$store.commit('CreateAudienceStore/SET_SCHEDULER_ACTIVATION_FREQUENCY', value)
            }
        },
        recurrence_type: {
            get() {
                return this.$store.getters['CreateAudienceStore/getSchedulerRecurrenceType']
            },
            set(value) {
                this.$store.commit('CreateAudienceStore/SET_SCHEDULER_RECURRENCE_TYPE', value)
            }
        },
        ending_type: {
            get() {
                return this.$store.getters['CreateAudienceStore/getSchedulerEndingType']
            },
            set(value) {
                this.$store.commit('CreateAudienceStore/SET_SCHEDULER_ENDING_TYPE', value)
            }
        },
        recurrences: {
            get() {
                return this.$store.getters['CreateAudienceStore/getSchedulerEndingRecurrences']
            },
            set(value) {
                this.$store.commit('CreateAudienceStore/SET_SCHEDULER_ENDING_RECURRENCES', value)
            }
        },
        auto_activate: {
            get() {
                return this.$store.getters['CreateAudienceStore/getSchedulerAutoActivateStatus']
            },
            set(value) {
                this.$store.commit('CreateAudienceStore/SET_SCHEDULER_AUTO_ACTIVATE_STATUS', value)
            }
        },
        period: {
            get() {
                return this.$store.getters['CreateAudienceStore/getSchedulerPeriod']
            },
            set(value) {
                this.$store.commit('CreateAudienceStore/SET_SCHEDULER_PERIOD', value)
            }
        }
    },
    watch: {
        act_frequency: function () {
            let period = 30
            if (this.act_frequency === 'daily') {
                period = 1
            } else if (this.act_frequency === 'monthly') {
                period = 30
            } else if (this.act_frequency === 'weekly') {
                period = 7
            } else if (this.act_frequency === 'bi-weekly') {
                period = 30
            }

            this.$store.commit('CreateAudienceStore/SET_SCHEDULER_PERIOD', period)
        },
        time: function () {
            let full_time = this.$store.getters['CreateAudienceStore/getSchedulerStartDate'] + ' ' + this.time + ':00'

            this.$store.commit('CreateAudienceStore/SET_SCHEDULER_FULL_TIME', full_time)
        }
    },
    mounted() {
        if (this.dataObject !== undefined) {
            this.usePropsData()
        }

        this.$store.dispatch('CreateAudienceStore/fetchAnalysisTypes')
    }
}
</script>

<style type="scss">
.ending-type .v-input--radio-group__input .v-radio .v-input--selection-controls__input {
    display: block !important;
}

.custom-input .v-input__control .v-input__slot .v-text-field__slot input,
.custom-input .v-input__control .v-input__slot .v-select__slot input {
    text-align: center !important;
}

</style>